import React from 'react';
import Draggable from 'react-draggable';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ImageIcon from '../UI/icon/image-icon';

function ModernConfirmModal(props) {
    const {
        showModal,
        closeModal,
        setData,
        modalClassName,
        modalTitle,
        connfirmMsg,
        mainIcon,
        onAction,
        onCancelAction,
        isToggle = false,
        modalMinWidth = "306px",
        modalMaxWidth = "306px",
    } = props;
    return (
        <Draggable handle=".cursor">
            <Modal
                isOpen={showModal}
                className="no-cursor modern-modal"
                modalClassName={modalClassName}
                toggle={isToggle ? () => {
                    closeModal(setData);
                } : null}
                style={{ minWidth: modalMinWidth, maxWidth: modalMaxWidth }}
            >
                <ModalHeader
                    className="modal-header modal-title cursor"
                    toggle={() => {
                        closeModal(setData);
                    }}
                >
                    {modalTitle}
                </ModalHeader>
                <ModalBody>
                    <div className='confirm-box'>
                        <div className='flex-column align-items-center'>
                            <ImageIcon
                                mainClass={mainIcon?.mainClass}
                                iconClass={mainIcon?.iconClass}
                                title={mainIcon?.title} />
                            <p>{connfirmMsg?.mainMsg}</p>
                        </div>
                        <hr />
                        <div className='btn-container m-0'>
                            <button
                                type="button"
                                className="btn btn-light-danger"
                                onClick={() => onCancelAction ? onCancelAction() : closeModal(setData)}
                            >
                                {connfirmMsg?.cancelTitle || "No"}
                            </button>
                            {onAction &&
                                <button
                                    type="button"
                                    className="btn btn-yellow-default waves-effect"
                                    onClick={onAction}
                                >
                                    {connfirmMsg?.actionTitle || "Yes"}
                                </button>}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </Draggable>
    )
}

export default ModernConfirmModal